export class SingleScoreState {
	constructor(
		public score: number = 0,
		public note: string = '',
		public scoreTouched: boolean = false,
	) {}
}
